import { useEffect, useState } from 'react';

// Match the landing stylesheet. Layout follows viewport width, never device identity.
export const MOBILE_QUERY = '(max-width: 768px)';
export default function useMobileViewport() {
  const [mobile, setMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(MOBILE_QUERY);
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);
  return mobile;
}
